// extracted by mini-css-extract-plugin
export default {"icon":"DisconnectCart_icon__scYeH","separator":"DisconnectCart_separator__Rtv3L","fullView":"DisconnectCart_fullView__Rnvjz","shimmer":"DisconnectCart_shimmer__yAS4c"};